import subscribeToPlaybackApiResponse from './Subscribers/subscribeToPlaybackApiResponse';

const connectResumePointsSubscriptions = middleware => [
    subscribeToPlaybackApiResponse(
        middleware.apiServices.playback.response$,
        middleware.state.stores.resumePoints
    ),
];

export default connectResumePointsSubscriptions;
